import { RootState } from '../store'

export const selectControlPlaneToken = (state: RootState) => state.controlPlane.token
export const selectControlPlaneOwner = (state: RootState) => state.controlPlane.owner
export const selectControlPlaneAuthLoading = (state: RootState) => state.controlPlane.authLoading
export const selectControlPlaneAuthError = (state: RootState) => state.controlPlane.authError
export const selectMyOrganizations = (state: RootState) => state.controlPlane.organizations
export const selectOrganizationsLoading = (state: RootState) => state.controlPlane.organizationsLoading
export const selectCreatingOrganization = (state: RootState) => state.controlPlane.creating
export const selectCreateOrganizationError = (state: RootState) => state.controlPlane.createError
export const selectLastCreateResult = (state: RootState) => state.controlPlane.lastCreateResult
export const selectOrganizationBilling = (organizationId: string) => (state: RootState) =>
  state.controlPlane.billing[organizationId]
export const selectBillingLoading = (state: RootState) => state.controlPlane.billingLoading
export const selectBillingError = (state: RootState) => state.controlPlane.billingError
